import { render } from "./Footer.vue?vue&type=template&id=25921aa2"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Footers/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25921aa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25921aa2', __exports__)) {
    api.reload('25921aa2', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=25921aa2", () => {
    api.rerender('25921aa2', render)
  })

}


export default __exports__